var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg064Pin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 10C4 16.44 11.12 21.6 11.42 21.81C11.7672 22.0572 12.2328 22.0572 12.58 21.81C12.88 21.6 20 16.44 20 10C20 5.58172 16.4183 2 12 2C7.58172 2 4 5.58172 4 10ZM18 10C18 14.44 13.61 18.42 12 19.73C10.39 18.42 6 14.44 6 10C6 6.68629 8.68629 4 12 4C15.3137 4 18 6.68629 18 10ZM12 12C13.1046 12 14 11.1046 14 10C14 8.89543 13.1046 8 12 8C10.8954 8 10 8.89543 10 10C10 11.1046 10.8954 12 12 12Z",
    fill: "#8199A6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg064Pin);
export default __webpack_public_path__ + "static/media/064-pin.a80c023d7b9540576107a45d0ed40886.svg";
export { ForwardRef as ReactComponent };